'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isBoolean(value) {
    return typeof value === 'boolean' || value instanceof Boolean;
}

exports.isBoolean = isBoolean;
